import { useContext, useEffect, useState } from 'react'

import { OrganizationContext } from 'components'
import { useAccountContext } from 'components/contexts/AccountContext'
import { UnleashContext } from 'components/providers/UnleashProvider'
import { CopilotLegalTermsStatus } from 'types/CopilotLegalTerms'

export enum SearchBarMode {
  none = 'none',
  globalSearch = 'globalSearch',
  copilot = 'copilot',
}

const useSearchBarMode = (): SearchBarMode => {
  const { currentAccount } = useAccountContext()
  const { copilotAIEnabled, context: unleashContext } = useContext(UnleashContext)
  const pbx = useContext(OrganizationContext)

  const [searchBarState, setSearchBarState] = useState(SearchBarMode.none)

  useEffect(() => {
    if (currentAccount && (currentAccount.orgId === null || currentAccount.orgId === undefined)) {
      setSearchBarState(SearchBarMode.globalSearch)
    } else if (
      currentAccount &&
      currentAccount.orgId &&
      pbx?.type &&
      currentAccount.key === unleashContext['accountKey'] &&
      pbx.type === unleashContext['pbxType']
    ) {
      if (pbx.copilotLegalTerms) {
        setSearchBarState(
          copilotAIEnabled && pbx.copilotLegalTerms.legalTermsStatus !== CopilotLegalTermsStatus.DECLINED
            ? SearchBarMode.copilot
            : SearchBarMode.globalSearch,
        )
      } else {
        setSearchBarState(copilotAIEnabled ? SearchBarMode.copilot : SearchBarMode.globalSearch)
      }
    }
  }, [currentAccount, pbx?.type, pbx?.copilotLegalTerms, copilotAIEnabled, unleashContext])

  return searchBarState
}

export default useSearchBarMode
